"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = require("node-fetch");
const types_1 = require("../types");
const getRequestHeaders = (_a) => __awaiter(void 0, [_a], void 0, function* ({ config, additionalHeaders, }) {
    const { oxygenId, getAccessToken, env, region } = config;
    const headers = new node_fetch_1.Headers(additionalHeaders);
    const token = yield getAccessToken();
    headers.append('Authorization', `Bearer ${token}`);
    if (region) {
        headers.append('Region', region);
    }
    if (oxygenId) {
        headers.append('x-user-id', oxygenId);
        if (env.toLowerCase() === types_1.ApiEnv.LOCAL) {
            headers.append('x-ads-token-data', JSON.stringify({ access_token: { userid: oxygenId } }));
        }
    }
    return headers;
});
exports.default = getRequestHeaders;
